import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { useMyContext } from '../../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser, FaUniversity } from "react-icons/fa";
import { Base_Url, Url_For_View_Document, accountUpdaterequest, resetuserpasswordapi } from '../../../config/config';
import { FaEye } from 'react-icons/fa'
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import {
  FaIdCard,
  FaAddressCard,
  FaTimes,
  FaEdit,
  FaSave,
} from 'react-icons/fa';



const ViewAllCustomer = ({ isopen, onClose, customer }) => {
  const { isDarkMode } = useMyContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [cancelledChequeFile, setCancelledChequeFile] = useState(null);
  const [mailScreenshotFile, setMailScreenshotFile] = useState(null);
  const [isResetMode, setIsResetMode] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };



  const handleResetPassword = async () => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+=\[\]{};':"\\|,.<>/?]).{8,}$/;

    if (!passwordRegex.test(password)) {
      toast.error("Password must be at least 8 characters long and include 1 uppercase letter and 1 special character.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(
        Base_Url + resetuserpasswordapi,
        {
          email: customer.email,
          password: password,
          c_password: confirmPassword,
        },
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        setIsResetMode(false);
        setPassword("");
        setConfirmPassword("");
        onClose();

      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Failed to reset password.");
    }
  };

  useEffect(() => {
    if (customer) {
      reset({
        Id: customer.id || '',
        Name: customer.name || '',
        email: customer.email || '',
        phone: customer.phone || '',
        company_name: customer.company_name || '',
        company_type: customer.company_type || '',
        status: customer.status || '0',
        profile_flag: customer.profile_flag || '0',
        user_address_image: customer.user_address_image || '',
        user_pancard_image: customer.user_pancard_image || '',
        user_gst_image: customer.user_gst_image || '',
        aadhar_status: customer.aadhar_status || '0',
        pan_card_status: customer.pan_card_status || '0',
        gst_status: customer.gst_status || '0',
        aadhar_number: customer.aadhar_number || '',
        pancard_number: customer.pancard_number || '',
        gst_number: customer.gst_number || '',
        role: customer.role || '',
        txn_amount: customer.txn_amount || '',
        wallet_status: customer.wallet_status || '0',
        create_date: customer.create_date || '',
        timestamp: customer.timestamp || '',
        account_holder_name: customer.account_holder_name || '',
        account_no: customer.account_no || '',
        bank_name: customer.bank_name || '',
        ifsc_code: customer.ifsc_code || '',
});
      setCancelledChequeFile(null);
      setMailScreenshotFile(null);
    }
  }, [customer, reset]);

  const handleFileChange = (event, setFileFunction) => {
    const file = event.target.files[0];
    if (file) {
      setFileFunction(file);
    }
  };

  const ViewDocument = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleClose = () => {
    setIsEditMode(false);
    setCancelledChequeFile(null);
    setMailScreenshotFile(null);
    onClose();
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append('user_id', customer.id || '');
    formData.append('bank_name', data.bank_name || '');
    formData.append('ifsc_code', data.ifsc_code || '');
    formData.append('account_holder', data.account_holder_name || '');
    formData.append('account_no', data.account_no || '');

    if (cancelledChequeFile) {
      formData.append('cancel_check', cancelledChequeFile);
    }
    if (mailScreenshotFile) {
      formData.append('mail_screenshort', mailScreenshotFile);
    }
    try {
      const response = await axios.post(Base_Url + accountUpdaterequest, formData, {
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'multipart/form-data',

        },
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        handleClose();
      } else {
        toast.error(response.data.message.cancel_check);
        toast.error(response.data.message.mail_screenshort);
        toast.error(response.data.message.bank_name);
        toast.error(response.data.message.account_holder);
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Failed to update account details');
    }
  };

  return (
    <Dialog
      open={isopen}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        className: "rounded-lg overflow-hidden"
      }}
    >
      <DialogTitle className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white relative shadow-lg">
        <h2 className="text-xl sm:text-2xl font-bold text-white font-sans px-2 py-3 flex items-center">
          <FaUser className="mr-3" size={26} />
          Customer Details
        </h2>
        <IoIosCloseCircle
          className="absolute top-3 right-3 cursor-pointer hover:scale-110 transition-transform"
          size={32}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent className="bg-gray-50 dark:bg-gray-900 custom-scrollbar" style={{ maxHeight: '75vh' }}>
        <div className="p-6 bg-white dark:bg-gray-800 shadow-md rounded-lg dark:text-gray-200">
          <form className="space-y-8 font-sans" onSubmit={handleSubmit(onSubmit, onErrors)}>

            {/* Primary Information Section */}
            <div className="bg-purple-50 dark:bg-gray-800 p-4 rounded-lg border-l-4 border-purple-500">
              <h3 className="text-lg font-bold mb-4 text-purple-700 dark:text-purple-300 flex items-center">
                <FaIdCard className="mr-2" />
                Primary Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">ID</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('Id')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Name</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('Name')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>
            </div>

            {/* Contact Information Section */}
            <div className="bg-blue-50 dark:bg-gray-800 p-4 rounded-lg border-l-4 border-blue-500">
              <h3 className="text-lg font-bold mb-4 text-blue-700 dark:text-blue-300 flex items-center">
                <FaAddressCard className="mr-2" />
                Contact Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Email</label>
                  <input
                    type="email"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('email')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Phone</label>
                  <input
                    type="tel"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('phone')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>
            </div>

            {/* Company Information Section */}
            <div className="bg-green-50 dark:bg-gray-800 p-4 rounded-lg border-l-4 border-green-500">
              <h3 className="text-lg font-bold mb-4 text-green-700 dark:text-green-300 flex items-center">
                <FaIdCard className="mr-2" />
                Company Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Company Name</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('company_name')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Company Type</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('company_type')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">GST Number</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('gst_number')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Profile Status</label>
                  <select
                    {...register('profile_flag')}
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    disabled={!isEditMode}
                  >
                    <option value="0">User Unverified</option>
                    <option value="1">User Verified</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Password Reset Section */}
            <div className="bg-amber-50 dark:bg-gray-800 p-4 rounded-lg border-l-4 border-amber-500">
              <h3 className="text-lg font-bold mb-4 text-amber-700 dark:text-amber-300 flex items-center">
                <FaIdCard className="mr-2" />
                Password Management
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm relative">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">New Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 pr-10 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} ${isResetMode ? "" : "bg-gray-100"}`}
                      disabled={!isResetMode}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute top-3 right-3 cursor-pointer text-gray-600 dark:text-gray-300"
                    >
                      {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                    </span>
                  </div>
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm relative">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Confirm Password</label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 pr-10 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} ${isResetMode ? "" : "bg-gray-100"}`}
                      disabled={!isResetMode}
                    />
                    <span
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute top-3 right-3 cursor-pointer text-gray-600 dark:text-gray-300"
                    >
                      {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Document Information */}
            <div className="bg-indigo-50 dark:bg-gray-800 p-4 rounded-lg border-l-4 border-indigo-500">
              <h3 className="text-lg font-bold mb-4 text-indigo-700 dark:text-indigo-300 flex items-center">
                <FaIdCard className="mr-2" />
                Document Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Aadhar Number</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('aadhar_number')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">PAN Card Number</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('pancard_number')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="space-y-4 mt-4">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-bold text-gray-700 dark:text-gray-300">Aadhar Card Image</label>
                    {customer?.user_address_image && (
                      <button
                        type="button"
                        className="flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_address_image)}
                      >
                        <FaEye size={18} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    />
                  ) : (
                    <input
                      type="text"
                      {...register('user_address_image')}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} bg-gray-100`}
                      disabled
                    />
                  )}
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-bold text-gray-700 dark:text-gray-300">PAN Card Image</label>
                    {customer?.user_pancard_image && (
                      <button
                        type="button"
                        className="flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_pancard_image)}
                      >
                        <FaEye size={18} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    />
                  ) : (
                    <input
                      type="text"
                      {...register('user_pancard_image')}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} bg-gray-100`}
                      disabled
                    />
                  )}
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-bold text-gray-700 dark:text-gray-300">GST Certificate</label>
                    {customer?.user_gst_image && (
                      <button
                        type="button"
                        className="flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_gst_image)}
                      >
                        <FaEye size={18} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    />
                  ) : (
                    <input
                      type="text"
                      {...register('user_gst_image')}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} bg-gray-100`}
                      disabled
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Bank Account Details */}
            <div className="bg-blue-50 dark:bg-gray-800 p-4 rounded-lg border-l-4 border-blue-500">
              <div className="flex items-center mb-4">
                <FaUniversity className="text-blue-700 dark:text-blue-300 mr-2" size={24} />
                <h3 className="text-lg font-bold text-blue-700 dark:text-blue-300">Bank Account Details</h3>
              </div>

              <p className="text-sm text-blue-600 dark:text-blue-300 mb-4 bg-blue-100 dark:bg-blue-900 p-3 rounded-lg">
                Please ensure all bank details are accurate. These details will be used for processing payments and transactions.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Account Holder Name</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('account_holder_name')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Bank Name</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('bank_name')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">Account Number</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('account_no')}
                    disabled={!isEditMode}
                  />
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">IFSC Code</label>
                  <input
                    type="text"
                    className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    {...register('ifsc_code')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-bold text-gray-700 dark:text-gray-300">Cancelled Cheque</label>
                    {customer?.cancel_check_image && (
                      <button
                        type="button"
                        className="flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.cancel_check_image)}
                      >
                        <FaEye size={18} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      onChange={(e) => handleFileChange(e, setCancelledChequeFile)}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    />
                  ) : (
                    <div className={`p-3 border border-gray-300 rounded-lg ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} bg-gray-100`}>
                      {customer?.cancel_check_image || 'No file uploaded'}
                    </div>
                  )}
                </div>

                <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <label className="text-sm font-bold text-gray-700 dark:text-gray-300">Account Approval Mail</label>
                    {customer?.account_appruve_mail && (
                      <button
                        type="button"
                        className="flex items-center text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.account_appruve_mail)}
                      >
                        <FaEye size={18} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      onChange={(e) => handleFileChange(e, setMailScreenshotFile)}
                      className={`p-3 border border-gray-300 w-full rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""}`}
                    />
                  ) : (
                    <div className={`p-3 border border-gray-300 rounded-lg ${isDarkMode ? "dark:bg-gray-700 dark:border-gray-600 dark:text-white" : ""} bg-gray-100`}>
                      {customer?.account_appruve_mail || 'No file uploaded'}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap gap-4 mt-8">
              <button
                type="button"
                onClick={() => setIsEditMode(!isEditMode)}
                className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-3 px-6 rounded-lg hover:from-purple-700 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 font-medium transition-colors flex items-center shadow-md"
              >
                {isEditMode ? (
                  <>
                    <FaTimes className="mr-2" /> Cancel Editing
                  </>
                ) : (
                  <>
                    <FaEdit className="mr-2" /> Edit Details
                  </>
                )}
              </button>

              {isEditMode && (
                <button
                  type="submit"
                  className="bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-6 rounded-lg hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 font-medium transition-colors flex items-center shadow-md"
                >
                  <FaSave className="mr-2" /> Save Changes
                </button>
              )}

              <button
                type="button"
                onClick={() => setIsResetMode(!isResetMode)}
                className={`${isResetMode ? 'bg-gradient-to-r from-gray-500 to-gray-600' : 'bg-gradient-to-r from-red-500 to-red-600'} text-white py-3 px-6 rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 font-medium transition-colors flex items-center shadow-md`}
              >
                {isResetMode ? 'Cancel Reset' : 'Reset Password'}
              </button>

              {/* {isResetMode && (
                <button
                  type="button"
                >
                  Reset Password
                </button>
              )} */}

              {isResetMode && (
                <button
                  onClick={handleResetPassword}
                  className="bg-green-500 text-white py-2 px-4 rounded-custom hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                  type="button"
                >
                  Confirm Reset
                </button>
              )}
            </div>

          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAllCustomer;
